export default __webpack_public_path__ + "static/media/logo-nasa.46ac1674.svg";